import {
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "model/FlexibleAttributeModel";
import { IAccountsReceivable, IBenefit, IFeesAndPremiums, IFlexibleField, IFlexibleFieldSet, IGroupConfigurationData, IGroupNumber, INonStandard, IPlan, IStopLoss } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

export class RemoveDeprecatedFields extends BaseJsonTransformer {

    config: FAM_IGroupConfigurationConfig;
    json: FAM_IGroupConfigurationData;
    log: string[];

    constructor({ config, json }: { config: FAM_IGroupConfigurationConfig, json: FAM_IGroupConfigurationData }) {
        super();
        this.config = config;
        this.json = json;
        this.log = [];
    }

    async transformGroupConfiguration(json: IGroupConfigurationData): Promise<void> {
        json.fields = this.processFields(json.fields);
    }

    async transformAttributeSet(attributeSet: IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> {
        attributeSet.fields = this.processFields(attributeSet.fields);
    }

    async transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void> {
        nonStandard.fields = this.processFields(nonStandard.fields);
    }

    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        benefit.fields = this.processFields(benefit.fields);
    }

    async transformAccountsReceivable(accountsReceivable: IAccountsReceivable): Promise<boolean | void> {
        accountsReceivable.fields = this.processFields(accountsReceivable.fields);
    }

    async transformStopLoss(stopLoss: IStopLoss): Promise<boolean | void> {
        stopLoss.fields = this.processFields(stopLoss.fields);
    }

    async transformFeesAndPremium(feesAndPremium: IFeesAndPremiums): Promise<boolean | void> {
        feesAndPremium.fields = this.processFields(feesAndPremium.fields);
    }

    async transformPlan(plan: IPlan): Promise<boolean | void> {
        plan.fields = this.processFields(plan.fields);
    }

    async transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void> {
        groupNumber.fields = this.processFields(groupNumber.fields);
    }

    processFields(fields: IFlexibleField[]): IFlexibleField[] {
        return fields.filter(eField => {

            let purge = false;

            const attribute = this.config.cache.map_bcbs_config_attribute[eField.configRef.id];

            if (!attribute) {
                console.warn("[tran] missing - attribute", eField.configRef)
                this.log.push(`missing attribute/${eField.configRef.name}/${eField.configRef.id}`)
                purge = true;
            } else {
                const masterAttribute = this.config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
                if (!masterAttribute) {
                    console.warn("[tran] missing - master attribute", attribute)
                    this.log.push(`missing master attribute missing`)
                    purge = true;
                }
            }

            if (purge) {
                eField.values.forEach(v => {
                    if (v.value) {
                        this.log.push(`field value present - attribute/${eField.configRef.name}/${eField.configRef.id} value/${v.value.type}`)
                    }
                })

                return false;
            }

            return true;

        });
    }
}
